namespace TabAurous.Stock {
    export namespace StoneService {
        export const baseUrl = 'Stock/StockStone';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ShapeList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SieveList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ColorList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SizeList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function QualityList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StockItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/StockStone/List",
            ShapeList = "Stock/StockStone/ShapeList",
            SieveList = "Stock/StockStone/SieveList",
            ColorList = "Stock/StockStone/ColorList",
            SizeList = "Stock/StockStone/SizeList",
            QualityList = "Stock/StockStone/QualityList"
        }

        [
            'List', 
            'ShapeList', 
            'SieveList', 
            'ColorList', 
            'SizeList', 
            'QualityList'
        ].forEach(x => {
            (<any>StoneService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
